import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";
import React, { useEffect, useState } from "react";
import { blogService } from "./publicservice/BlogsService";

const blogPosts = [

  
  {
    id: 1,
    image: "/assets/img/blog/blog-big-1-1.jpg",
    category: "Diamond",
    date: "December 1, 2025",
    title: "Both of which translate",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    id: 2,
    image: "/assets/img/blog/blog-big-1-2.jpg",
    category: "Diamond",
    date: "December 1, 2025",
    title: "Piece hanging down",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    id: 3,
    image: "/assets/img/blog/blog-big-1-3.jpg",
    category: "Diamond",
    date: "December 1, 2025",
    title: "Loose hanging piece",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
];

const recentPosts = [
  {
    id: 1,
    image: "/assets/img/blog/recent-post-1-1.jpg",
    title: "Structure Dial Design Watch",
    date: "09 Aug, 2025",
  },
  {
    id: 2,
    image: "/assets/img/blog/recent-post-1-2.jpg",
    title: "Piece old hanging down",
    date: "05 Mar, 2025",
  },
  {
    id: 3,
    image: "/assets/img/blog/recent-post-1-3.jpg",
    title: "Loose hanging piece watch",
    date: "20 Jan, 2025",
  },
];

const Blog: React.FC = () => {

  const [blogPosts, setBlogPosts] = useState<any[]>([]);
const [loading, setLoading] = useState(true);
  const postsPerPage = 2;
const [currentPage, setCurrentPage] = useState(1);

const totalPages = Math.ceil(blogPosts.length / postsPerPage);

const indexOfLastPost = currentPage * postsPerPage;
const indexOfFirstPost = indexOfLastPost - postsPerPage;

const currentPosts = blogPosts.slice(
  indexOfFirstPost,
  indexOfLastPost
);

useEffect(() => {
  loadBlogs();
}, []);

const loadBlogs = async () => {
  try {
    const res = await blogService.getAll();

   

    setBlogPosts(res);

    console.log(res,"check");
  } catch (error) {
    console.log("Error loading blogs:", error);
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <MobileMenu />
      <PopupSearch />

      <main className="main">
        <Header />
<link rel="stylesheet" href="/assets/css/blog.css" />
        {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
                backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <div className="container">
            <div className="breadcumb-content text-center">
             <h1 className="breadcumb-title">Our Blog</h1>
              <ul className="breadcumb-menu">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Our Blog</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Blog Section */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row">
              
              {/* Left Blog Posts */}
              <div className="col-lg-9">
             {currentPosts.map((post) => (
  <div className="vs-blog blog-style1 mb-5" key={post.blogID}>
    
    <div className="blog-img">
      <img
        src={`${post.blogImage}`}
        alt={post.blogTitle}
        className="img-fluid"
      />
    </div>

    <div className="blog-content">
      
      <div className="blog-meta">
        <span>{post.tags}</span>
        <span>
          {new Date(post.publishDate)
            .toLocaleDateString()}
        </span>
      </div>

      <h3 className="blog-title">
        {post.blogTitle}
      </h3>

      <p className="blog-text">
        {post.shortDescription}
      </p>

      <div className="blog-footer d-flex justify-content-between align-items-center">
        
        <a
          href={`/blog/${post.blogSlug}`}
          className="blog-link"
        >
          Read More →
        </a>

        <div className="blog-social">
          <a href="javascript:void(0)">IG</a>
          <a href="javascript:void(0)">FB</a>
          <a href="javascript:void(0)">LI</a>
        </div>

      </div>
    </div>
  </div>
))}

                {/* Pagination */}
               {/* Pagination */}
<div className="vs-pagination mt-60">
  <ul className="custom-pagination">
    
    {/* Prev */}
    <li>
      <button
        className="pagination-btn"
        onClick={() =>
          currentPage > 1 &&
          setCurrentPage(currentPage - 1)
        }
        disabled={currentPage === 1}
      >
        <i className="far fa-angle-double-left"></i>
      </button>
    </li>

    {/* Page Numbers */}
    {[...Array(totalPages)].map((_, index) => (
      <li key={index}>
        <button
          className={`pagination-btn ${
            currentPage === index + 1 ? "active-page" : ""
          }`}
          onClick={() => setCurrentPage(index + 1)}
        >
          {index + 1}
        </button>
      </li>
    ))}

    {/* Dots */}
    <li>
      <button className="pagination-btn dots-btn">
        ...
      </button>
    </li>

    {/* Next */}
    <li>
      <button
        className="pagination-btn"
        onClick={() =>
          currentPage < totalPages &&
          setCurrentPage(currentPage + 1)
        }
        disabled={currentPage === totalPages}
      >
        <i className="far fa-angle-double-right"></i>
      </button>
    </li>
  </ul>
</div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-3">
                <div className="sidebar-area">
                  
                  {/* About Widget */}
                  <div className="widget widget_about mb-4">
                    <img
                      src="/assets/img/blog/widget-profile-img-1-1.jpg"
                      alt="About"
                      className="img-fluid"
                    />
                    <h3>Amalia Elha</h3>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    </p>
                  </div>

                  {/* Categories */}
                  <div className="widget widget_categories mb-4">
                    <h3 className="widget_title">Categories</h3>
                   <div className="widget widget_categories mb-4">
  <h3 className="widget_title">Category</h3>

  <ul>
    <li>
      <a href="/BlogDetails">diamond pendant</a>
      <span>3</span>
      <img
        className="dot-shape"
        src="/assets/img/shapes/dot-shape-3.svg"
        alt="dot-shape"
      />
    </li>

    <li>
      <a href="/BlogDetails">necklace</a>
      <span>3</span>
      <img
        className="dot-shape"
        src="/assets/img/shapes/dot-shape-3.svg"
        alt="dot-shape"
      />
    </li>

    <li>
      <a href="/BlogDetails">woman ring</a>
      <span>3</span>
      <img
        className="dot-shape"
        src="/assets/img/shapes/dot-shape-3.svg"
        alt="dot-shape"
      />
    </li>

    <li>
      <a href="/BlogDetails">pendent</a>
      <span>3</span>
      <img
        className="dot-shape"
        src="/assets/img/shapes/dot-shape-3.svg"
        alt="dot-shape"
      />
    </li>
  </ul>
</div>
                  </div>

                  {/* Recent Posts */}
                <div className="widget mb-4">
  <h3 className="widget_title">Recent Post</h3>

  <div className="recent-post-wrap">
    <div className="recent-post">
      <div className="media-img">
        <a href="/BlogDetails">
          <img
            src="/assets/img/blog/recent-post-1-1.jpg"
            alt="Blog Image"
          />
        </a>
      </div>

      <div className="media-body">
        <h4 className="post-title">
          <a className="text-inherit" href="/BlogDetails">
            Struure Dial design watch
          </a>
        </h4>

        <div className="recent-post-meta">
          <span>09 Aug, 2025</span>
        </div>
      </div>
    </div>

    <div className="recent-post">
      <div className="media-img">
        <a href="/BlogDetails">
          <img
            src="/assets/img/blog/recent-post-1-2.jpg"
            alt="Blog Image"
          />
        </a>
      </div>

      <div className="media-body">
        <h4 className="post-title">
          <a className="text-inherit" href="/BlogDetails">
            piece old hanging down
          </a>
        </h4>

        <div className="recent-post-meta">
          <span>05 Mar, 2025</span>
        </div>
      </div>
    </div>

    <div className="recent-post">
      <div className="media-img">
        <a href="/BlogDetails">
          <img
            src="/assets/img/blog/recent-post-1-3.jpg"
            alt="Blog Image"
          />
        </a>
      </div>

      <div className="media-body">
        <h4 className="post-title">
          <a className="text-inherit" href="/BlogDetails">
            loose hanging piece watch
          </a>
        </h4>

        <div className="recent-post-meta">
          <span>20 Jan, 2025</span>
        </div>
      </div>
    </div>
  </div>
</div>

                  {/* Tags */}
                  <div className="widget widget_tags mb-4">
                    <h3 className="widget_title">Tags</h3>

                    <div className="tagcloud">
                      <a  href="javascript:void(0)">diamond</a>
                      <a  href="javascript:void(0)">necklace</a>
                      <a  href="javascript:void(0)">rings</a>
                      <a  href="javascript:void(0)">wedding ring</a>
                      <a  href="javascript:void(0)">pendant</a>
                    </div>
                  </div>
<div
  className="widget widget_tags wow animate__fadeInUp"
  style={{ visibility: "visible", animationName: "fadeInUp" }}
>
  <h3 className="widget_title">Tags</h3>

  <div className="sidebar-gallery">
    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-1.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-1.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>

    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-2.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-2.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>

    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-3.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-3.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>

    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-4.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-4.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>

    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-5.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-5.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>

    <div className="gallery-thumb">
      <img
        src="/assets/img/widget/gal-1-6.jpg"
        alt="Gallery"
        className="w-100"
      />
      <a
        href="/assets/img/widget/gal-1-6.jpg"
        className="popup-image gal-btn"
      >
        <i className="fal fa-plus"></i>
      </a>
    </div>
  </div>
</div>
                  {/* Search */}
               <div className="widget">
  <h3 className="widget_title">Search</h3>

  <form className="search-form">
    <input
      type="text"
      placeholder="Type here..."
    />

    <button type="submit" className="search-btn">
      <i className="far fa-search"></i>
    </button>
  </form>
</div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default Blog;